import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import { Page, Section } from 'react-page-layout';
import MainSidebar from 'components/main-sidebar';
import BoosterBar from 'components/booster-bar';
import CategoriesMenu from 'components/categories-menu';
import CmsPlaceholder from 'components/cms-placeholder';

class Dashboard extends PureComponent {
    static propTypes = {
        setActiveCategory: PropTypes.func.isRequired,
        resetBreadcrumbs: PropTypes.func.isRequired,
        setMainContentIsLoaded: PropTypes.func.isRequired,
    };

    componentWillMount() {
        this.props.setActiveCategory({ category: null });
    }

    componentDidMount() {
        this.props.resetBreadcrumbs();
    }

    render() {
        const { setMainContentIsLoaded } = this.props;
        return (
            <Page layout="two-columns" facet="narrow">
                <Section slot="sidebar">
                    <MainSidebar>
                        <CategoriesMenu/>
                    </MainSidebar>
                </Section>
                <Section slot="content">
                    <div className="page">
                        <BoosterBar/>
                        <div className="page--content">
                            <CmsPlaceholder onLoaded={() => setMainContentIsLoaded({ isLoaded: true })} id="dashboard"/>
                        </div>
                    </div>
                </Section>
            </Page>
        );
    }
}

export default connect(
    null,
    reduxUtils.mapDispatchToProps(({
        resetBreadcrumbs: 'breadcrumbs.reset',
        setActiveCategory: 'categories.setActiveCategory',
        setMainContentIsLoaded: 'main-content.setIsLoaded',
    })),
)(Dashboard);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/templates/dashboard/index.js